import { appstr } from "../utils/appstr";
import { QAlert } from "./QAlert";
import { QBuildTableRFC } from "./QBuildTableRFC";
import { Globals } from "./Globals";

export class QUpdateTableRFC extends QBuildTableRFC {
  constructor() {
    super();
  }

  DoTransactionComplete(response, callBackObj) {
    var wsMgr = Globals._wsMgr;
    var r = JSON.parse(response);
    var success = r["success"];
    var tableMgr = callBackObj?.fTableMgr ?? wsMgr?.fTableManager;
    if (Globals._wsMgr.fWaiting) {
      Globals._wsMgr.ClearAppLoadingAnimation();
      Globals._wsMgr.fWaiting = null;
    }
    if (!success) {
      var alert = new QAlert();
      alert.InitAlert(
        appstr("Unable to Save Changes"),
        appstr("SystemError") +
          "\n" +
          appstr("Error") +
          ": " +
          "'" +
          r["message"] +
          "'" +
          ", Code: " +
          r["code"],
        this.fPortPanel,
        wsMgr
      );
      wsMgr.PrepRenderWS();
      wsMgr.RenderWS();
      return;
    } else if (["00001", "00002"].includes(r["code"])) {
      var alert = new QAlert();
      alert.InitAlert(appstr("appenddata"), r["message"], callBackObj, wsMgr);
    } else if (r["code"] == "00003") callBackObj?.InitialLoadCheck?.(true);

    tableMgr?.LoadOverrides(r["overrides"]);
    callBackObj?.UpdatePanel?.();

    if (r["indexPos"] != null) {
      callBackObj?.SelectAfterReorder?.(r["indexPos"]);
    }

    Globals._wsMgr.BroadcastTopic("SyncTableManager", tableMgr);

    callBackObj?.HandleSendUpdateResponse?.(response);

    wsMgr.PrepRenderWS();
    wsMgr.RenderWS();
  }
}
